window.app.controller("robotaCtrl", [
  "$scope",
  "$http",
  "$compile",
  "$sce",
  function ($scope, $sce, $http, $compile, $timeout, $q, $log) {
    $scope.showFilters = false;
    $scope.model = {
      regionId: null,
      cityId: null,
      search: "",
      salaryMin: null,
      salaryMax: null,
      hideOffersWithoutSalary: false,
      categoryId: "",
      start: 0,
      limit: 10,
    };

    $scope.isDesktop = false;
    $scope.isMobile = false;

    $scope.searchText = "";
    $scope.searchCity = "";
    $scope.allRegions;
    $scope.allCities;

    $scope.filteredCities;

    $scope.screenWidth = function () {
      if (window.screen.width >= 730) {
        $scope.isDesktop = true;
      } else {
        $scope.isMobile = true;
      }
    };

    $scope.toggleFilters = function () {
      $scope.showFilters = !$scope.showFilters;

    };
    $scope.throttle = function (func, ms) {
      let isThrottled = false,
        savedArgs,
        savedThis;

      function wrapper() {
        if (isThrottled) {
          // (2)
          savedArgs = arguments;
          savedThis = this;
          return;
        }

        func.apply(this, arguments); // (1)

        isThrottled = true;

        setTimeout(function () {
          isThrottled = false; // (3)
          if (savedArgs) {
            wrapper.apply(savedThis, savedArgs);
            savedArgs = savedThis = null;
          }
        }, ms);
      }

      return wrapper;
    };

    //SALARY RANGE + REQUEST
    $scope.adjustLeftSlider = function () {
      if (!$scope.model.salaryMax || !$scope.model.salaryMin) return;

      if ($scope.model.salaryMax < $scope.model.salaryMin + 2500) {
        $scope.model.salaryMin = $scope.model.salaryMax - 2500;

        if ($scope.model.salaryMin == $scope.salaryMin) {
          $scope.model.salaryMax = $scope.salaryMin + 2500;
        }
      }
    };

    $scope.adjustRightSlider = function () {
      if (!$scope.model.salaryMax || !$scope.model.salaryMin) return;

      if ($scope.model.salaryMin > $scope.model.salaryMax - 2500) {
        $scope.model.salaryMax = $scope.model.salaryMin + 2500;

        if ($scope.model.salaryMax == $scope.salaryMax) {
          $scope.model.salaryMin = $scope.salaryMax - 2500;
        }
      }
    };

    $scope.salaryMax;
    $scope.slaryMin;
    $scope.getSalaries = function () {
      $scope.sendXHR({
        url: `https://ekassa.eu/racoon/product/getSalaries`,
        method: "GET",
        headers: { Authorization: "Basic aW52ZXN0OmtzYmY7YSVmc2xsc2dAcQ==" },
        dataAsParam: false,
        successFunc: function success(response) {
          const step =
            100 -
            ((response.data.data.salaryMax - response.data.data.salaryMin) %
              100);

          $scope.salaryMin = response.data.data.salaryMin;
          $scope.salaryMax = response.data.data.salaryMax + step;
          $scope.model.salaryMin = response.data.data.salaryMin;
          $scope.model.salaryMax = response.data.data.salaryMax + step;
        },
      });
    };
    $scope.getSalaries();
    //END SALARY RANGE + REQUEST

    //REGION + REQUEST
    $scope.getRegions = function () {
      $scope.sendXHR({
        url: `https://ekassa.eu/racoon/product/getRegions`,
        method: "GET",
        headers: { Authorization: "Basic aW52ZXN0OmtzYmY7YSVmc2xsc2dAcQ==" },
        dataAsParam: false,
        successFunc: function success(response) {
          $scope.allRegions = response.data.map(function (region) {
            return {
              value: region.id,
              display: region.name,
            };
          });
        },
      });
    };
    $scope.getRegions();
    //END REGION + REQUEST


    $scope.getFilteredStates = function(searchText, queryArray) {
      if (!searchText) return queryArray;

      let q = searchText.toLowerCase()
          .replace(/ą/g, 'a')            
          .replace(/ę/g, 'e')
          .replace(/í/g, 'i')
          .replace(/ó/g, 'o')
          .replace(/ń/g, 'n')
          .replace(/ć/g, 'c')
          .replace(/ł/g, 'l')
          .replace(/ś/g, 's')
          .replace(/ź/g, 'z')
          .replace(/ż/g, 'z');

      let results = queryArray
        .reduce(function(res, state) {
          let idx = state.display.toLowerCase()
          .replace(/ą/g, 'a')            
          .replace(/ę/g, 'e')
          .replace(/í/g, 'i')
          .replace(/ó/g, 'o')
          .replace(/ń/g, 'n')
          .replace(/ć/g, 'c')
          .replace(/ł/g, 'l')
          .replace(/ś/g, 's')
          .replace(/ź/g, 'z')
          .replace(/ż/g, 'z')
          .indexOf(q);

          if(idx === 0) {
            res[0].push(state)
          } else if(idx > 0) {
            res[1].push(state)
          }
          return res;   
        },[[],[]])
      return results[0].concat(results[1]);
    }

    //CITY + REQUEST
    $scope.getCities = function () {
      $scope.sendXHR({
        url: `https://ekassa.eu/racoon/product/getCities`,
        method: "GET",
        headers: { Authorization: "Basic aW52ZXN0OmtzYmY7YSVmc2xsc2dAcQ==" },
        dataAsParam: false,
        successFunc: function success(response) {
          $scope.allCities = response.data.map(function (city) {
            return {
              value: city.id,
              display: city.name,
              region: city.region.id
            };
          });
          $scope.filteredCities = Array.slice($scope.allCities);
        },
      });
    };
    $scope.getCities();
    //END CITY + REQUEST

    $scope.filterCities = function (region) {
      $scope.model.regionId = region && region.value || null;
      if (!region) {
        $scope.filteredCities = Array.slice($scope.allCities);
        return;
      }
      $scope.filteredCities = $scope.allCities.filter(city => city.region === region.value);
    }

    $scope.setCityId = function (city) {
      $scope.model.cityId = city && city.value || null;
      console.log(city);
    }

    //CATEGORIES + REQUEST
    $scope.getCategories = function () {
      $scope.sendXHR({
        url: `https://ekassa.eu/racoon/product/getCategories`,
        method: "GET",
        headers: { Authorization: "Basic aW52ZXN0OmtzYmY7YSVmc2xsc2dAcQ==" },
        dataAsParam: false,
        successFunc: function success(response) {
          $scope.categories = response.data;
        },
      });
    };
    $scope.getCategories();
    //END CATEGORIES + REQUEST

    $scope.getVacancies = function (pagination) {
      let headers = new Headers();

      if (pagination === false) {
        $scope.currentPage = 0;
        $scope.model.start = 0;
      }
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Basic aW52ZXN0OmtzYmY7YSVmc2xsc2dAcQ==");
      $scope.sendXHR({
        url: `https://ekassa.eu/racoon/product/getJobOffers`,
        method: "GET",
        params: $scope.model,
        headers: { Authorization: "Basic aW52ZXN0OmtzYmY7YSVmc2xsc2dAcQ==" },
        dataAsParam: false,
        successFunc: function success(response) {
          $scope.vacancies = response.data.data.jobOffers;
          $scope.countVacancies = response.data.data.count;

          $scope.numberOfPages = Math.ceil($scope.countVacancies / $scope.model.limit);
        },
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    $scope.getVacancies(false);

    $scope.changePage = function (pageNumber) {
      $scope.currentPage = pageNumber;
      $scope.model.start = $scope.model.limit * pageNumber;
      $scope.getVacancies(true);
    }

    $scope.currentPage = 0;
    $scope.model.limit = 10;
  },
]);



// WEBPACK FOOTER //
// src/js/controllers/offers/finOffers/robotaCtrl.js